/**
 * The anchor labels the stiffening plan prints per segment — the backend's
 * `StiffeningAnchorLabelKind`.
 */
export const STIFFENING_ANCHOR_LABEL_KINDS = [
  'tensile-anchor-start',
  'shear-anchor',
  'tensile-anchor-end',
] as const

export type StiffeningAnchorLabelKind = typeof STIFFENING_ANCHOR_LABEL_KINDS[number]

/**
 * Label guid of a segment's anchor label. Anchors are no elements of their own, so their labels
 * (and their persisted plan label positions) are keyed by the segment guid and the anchor kind,
 * exactly like the export's `stiffening_anchor_label_guid`.
 */
export const getStiffeningAnchorLabelGuid = (
  segmentGuid: string,
  kind: StiffeningAnchorLabelKind,
): string => `${segmentGuid}-${kind}`

/** The segment guid and anchor kind of an anchor label guid, `null` for any other guid. */
export const parseStiffeningAnchorLabelGuid = (
  guid: string,
): { segmentGuid: string; kind: StiffeningAnchorLabelKind } | null => {
  for (const kind of STIFFENING_ANCHOR_LABEL_KINDS) {
    const suffix = `-${kind}`
    if (guid.length > suffix.length && guid.endsWith(suffix)) {
      return { segmentGuid: guid.slice(0, -suffix.length), kind }
    }
  }
  return null
}
